
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/anomalies",
      function () {
        return require("private-next-pages/info/anomalies.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/anomalies"])
      });
    }
  